




































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Icon from '../common/Icon.vue';

@Component({
  components: { Icon },
})
export default class PaperItemRearrange extends Vue {
  @Inject('movePaperItem')
  movePaperItem!: (romIndex: number, toIndex: number) => void;

  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBrandDarkSecondary')
  colorBrandDarkSecondary!: string;

  @Inject('colorGrayLightSecondary')
  colorGrayLightSecondary!: string;

  @Prop({ required: true })
  index: number;

  @Prop({ required: true })
  numberOrder: number;

  @Prop({ required: true })
  totalPaperItems: number;

  @Prop({ required: true })
  isObjective: boolean;

  @Prop({ default: 1 })
  subjectiveTitleIndex: number;

  get isFirstItem() {
    return (
      (this.isObjective && this.index === 1) ||
      (!this.isObjective &&
        (this.index === 2 || this.subjectiveTitleIndex + 1 === this.index))
    );
  }

  get isLastItem() {
    return (
      (this.isObjective && this.subjectiveTitleIndex === this.index + 1) ||
      (!this.isObjective && this.totalPaperItems === this.index + 1)
    );
  }

  arrowUpClicked() {
    if (this.isFirstItem) return;
    const fromIndex = this.index;
    const toIndex = fromIndex - 1;

    this.movePaperItem(fromIndex, toIndex);
  }

  arrowDownClicked() {
    if (this.isLastItem) return;

    const fromIndex = this.index;
    const toIndex = fromIndex + 1;

    this.movePaperItem(fromIndex, toIndex);
  }
}
